import _ from "lodash";
import client from "lib/apolloClient/client";
import { getAITutorConversationQuery } from "./AITutorChatQueries";

export const getAITutorConversationFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAITutorConversationQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const writeAITutorConversationInCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAITutorConversationQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getAITutorConversation = async variables => {
  try {
    const response = await client.query({
      query: getAITutorConversationQuery,
      variables,
      fetchPolicy: "network-only",
    });

    return _.get(response, "data.node", {});
  } catch (error) {}
};
